module.exports = require("errno");